import clsx from 'clsx';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { CAROUSEL_LABELS } from '../approvalCarousel.definitions';
import type { CarouselArrowProps } from '../approvalCarousel.types';

export function CarouselArrow({ direction, disabled, onClick }: CarouselArrowProps) {
    const isPrev = direction === 'prev';
    const Icon = isPrev ? ChevronLeftIcon : ChevronRightIcon;

    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            aria-label={isPrev ? CAROUSEL_LABELS.prev : CAROUSEL_LABELS.next}
            className={clsx(
                'inline-flex h-9 w-9 items-center justify-center rounded-full border bg-white transition-colors',
                'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500',
                disabled
                    ? 'cursor-not-allowed border-gray-100 text-gray-300'
                    : 'border-primary-200 text-primary-700 hover:bg-primary-50'
            )}
        >
            <Icon className="h-5 w-5" aria-hidden="true" />
        </button>
    );
}

export default CarouselArrow;
